<template>

  <m-pay-layout>
    <v-layout :column="$vuetify.breakpoint.smAndDown">
      <v-flex>
        <v-card class="mb-3 mx-2">
          <v-card-title>
            <span class="headline">Create Shipping Method</span>
          </v-card-title>
          <v-card class="mb-3 mx-2" max-width="700px">
            <m-pay-shipping-method-editor
              :shippingMethod="newMethod"
              :loading="loading"
              @cancel="cancel"
              @submit="addMethod"
            />
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </m-pay-layout>

</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayShippingMethodEditor from './MPayShippingMethodEditor';

export default {
  name: 'MPayMerchantShippingMethodCreateView',

  components: { MPayShippingMethodEditor },

  data: () => ({
    newMethod: {
      id: '',
      name: '',
      extId: '',
      methodId: '',
    },
    loading: false,
    shippingMethods: [],
  }),

  methods: {
    cancel() {
      this.$router.push({ name: 'shipping-methods' });
    },
    addMethod(newMethod) {
      this.loading = true;
      axios.post(queries.addMerchantShippingMethod(), newMethod)
        .then(() => {
          this.loading = false;
          // this.$router.push({ name: 'shipping-methods' });
          this.showSuccessMessage('Method successfully added');
        })
        .catch((e) => {
          this.handleError(e);
        });
    },
    handleError(e) {
      this.showError(e);
      this.loading = false;
    },
    fetchMerchantShippingMethod(msmId) {
      if (this.$route.query.created) {
        this.showSuccessMessage('Widget successfully created');
      } else {
        this.loading = true;
        axios.get(queries.merchantShippingMethod(msmId))
          .then((response) => {
            this.newMethod = response.data;
            this.loading = false;
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      }
    },
    fetchShippingMethods() {
      this.loading = true;
      axios.get(queries.shippingMethods())
        .then((response) => {
          this.shippingMethods = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
  },
  created() {
    this.fetchShippingMethods();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantShippingMethodCreateView.vue